import { Dispatch, FC, ReactElement, Ref, SetStateAction, forwardRef, useState } from "react";
import {
    Grid, Dialog, DialogTitle, DialogContent, DialogContentText,
    DialogActions, Slide, Box, Typography
} from "@mui/material";
import { Dayjs } from 'dayjs';
import { TransitionProps } from "@mui/material/transitions";
import { AxiosInstance } from "axios";
import LoadingButton from "@mui/lab/LoadingButton";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import SaveIcon from '@mui/icons-material/Save';
import { btnStyle } from "../user/Tabs/utilisateur/UtilisateurRow";
import Calendar from "react-calendar";
import "./Calendar.css";
import { DateLock } from "./DateVerrouillage";
import { AlertType } from "../../../../types/AlertType";
import { AllMounth } from "../../../../constants/Constants";
import LockClockIcon from '@mui/icons-material/LockClock';
import LockPersonIcon from '@mui/icons-material/LockPerson';

const Transition = forwardRef(function Transition(
    props: TransitionProps & {
        children: ReactElement<any, any>;
    },
    ref: Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

interface DateVerrouillageRowProps {
    dateVerr: DateLock;
    selectedYear: Dayjs | null;
    index: number;
    http: AxiosInstance;
    setOpenSnack: Dispatch<SetStateAction<boolean>>;
    setAlerteMessage: Dispatch<SetStateAction<string>>;
    setAlertType: Dispatch<SetStateAction<AlertType>>;
    reloadList: () => void;
}

const DateVerrouillageRow: FC<DateVerrouillageRowProps> = ({
    dateVerr,
    selectedYear,
    index,
    http,
    setOpenSnack,
    setAlertType,
    setAlerteMessage,
    reloadList
}) => {
    const year = selectedYear?.year();

    const [openModal, setOpenModal] = useState<boolean>(false);
    const [openModalchoice, setOpenModalchoice] = useState<boolean>(false);
    const [openModalCloture, setOpenModalCloture] = useState<boolean>(false);
    const [loadingButton, setLoadingButton] = useState<boolean>(false);

    const [dateToSave, setDateToSave] = useState<DateLock>(dateVerr);

    const handleChangeDate = (e: any) => {
        const decoup = String(e).split(' ');
        console.log(decoup);
        const month = String(index + 1).padStart(2, '0');
        const changeDate = `${year}-${month}-${decoup[2]}`;

        setDateToSave({
            ...dateToSave,
            date_verouillage: changeDate
        });
        // setOpenModal(true);
        setOpenModalchoice(true);
    }

    const handleSave = async () => {
        setLoadingButton(true);
        const data = {
            ...dateToSave,
            id: dateVerr?.id,
            annee: dateVerr?.annee
        };
        await http.post('date-verrouillage/save', data)
            .then(() => {
                setAlerteMessage("Enregistrement efféctuée !");
                setAlertType("success");
                setOpenSnack(true);
                setOpenModal(false);
                reloadList();
            }).catch(error => {
                console.log(error);
            }).finally(() => {
                setLoadingButton(false);
            });
    }

    const handleSaveCloture = async () => {
        console.log("cloture");
        setLoadingButton(true);
        const data = {
            ...dateToSave,
            id: dateVerr?.id_date_cloture,
            annee: dateVerr?.annee
        };
        await http.post('date-verrouillage/save/cloture', data)
            .then(() => {
                setAlerteMessage("Enregistrement efféctuée !");
                setAlertType("success");
                setOpenSnack(true);
                setOpenModalCloture(false);
                window.location.reload();
            }).catch(error => {
                console.log(error);
            }).finally(() => {
                setLoadingButton(false);
            });
    }

    const handleClose = () => {
        setOpenModal(false);
        setDateToSave(dateVerr);
    }

    const dateToLock = () => {
        let monthToLock;
        let yearToLock = year!;
        switch (index) {
            case 0:
                monthToLock = "Décembre";
                yearToLock -= 1;
                break;
            case 1:
                monthToLock = "Janvier";
                break;
            case 2:
                monthToLock = "Février";
                break;
            case 3:
                monthToLock = "Mars";
                break;
            case 4:
                monthToLock = "Avril";
                break;
            case 5:
                monthToLock = "Mai";
                break;
            case 6:
                monthToLock = "Juin";
                break;
            case 7:
                monthToLock = "Juillet";
                break;
            case 8:
                monthToLock = "Août";
                break;
            case 9:
                monthToLock = "Septembre";
                break;
            case 10:
                monthToLock = "Octobre";
                break;
            case 11:
                monthToLock = "Novembre";
                break;
        }

        return `${monthToLock} ${yearToLock}`;
    };

    const minDate = new Date(`${year}-${index + 1}-01`);

    const maxDate = new Date(minDate.getFullYear(), minDate.getMonth() + 1, 0);

    const decoupDate = dateToSave.date_verouillage?.split('-');

    const dialogMsg = `La date ${decoupDate[2]}-${decoupDate[1]}-${decoupDate[0]} sera la date de
                       verrouillage pour le mois de ${dateToLock()}. Etes-vous sûr de cela SVP ?`;

    const calendarTitle = `${AllMounth[index]?.mounth} ${year}`;

    const tileClassName = ({ activeStartDate, date, view }: { activeStartDate: Date, date: Date, view: string }) => {
        // Pour Colorer En Rouge La Date De Cloture
        if (date.getDate() === parseInt(dateVerr.date_cloture?.split('-')[2])) {
            return 'highlighted-date-cloture';
        }
        console.log(parseInt(dateVerr.date_cloture?.split('-')[2]));
    };


    return (
        <>
            <Grid item xs={3} sm={3} md={3}>
                <Box>
                    <Box
                        pl={2}
                        pt={1}
                        sx={{
                            height: 36,
                            background: "#fff",
                            color: "#080d24",
                            fontWeight: "bold"
                        }}>
                        <Typography variant="subtitle2">{calendarTitle}</Typography>
                    </Box>
                    <Calendar
                        onChange={handleChangeDate}
                        value={[dateVerr.date_cloture, dateVerr.date_verouillage]}
                        activeStartDate={minDate}
                        minDate={minDate}
                        maxDate={maxDate}
                        showNavigation={false}
                        selectRange={false}
                        tileClassName={tileClassName}
                    />
                </Box>
            </Grid>
            <Dialog
                open={openModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>{"Confirmation Date De Verouiilage"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        {dialogMsg}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <LoadingButton
                        onClick={() => handleSave()}
                        startIcon={<SaveIcon />}
                        loading={loadingButton}
                        loadingPosition="end"
                        sx={btnStyle({
                            bgColor: "#FC8404",
                            hoverColor: "#FF9456"
                        })}
                        variant="contained"
                    >
                        Oui
                    </LoadingButton>
                    <LoadingButton
                        onClick={() => handleClose()}
                        startIcon={<ExitToAppIcon />}
                        sx={{ textTransform: "none" }}
                        loadingPosition="end"
                        variant="contained"
                        color="inherit"
                    >
                        Non
                    </LoadingButton>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openModalchoice}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => {
                    setOpenModalchoice(false);
                }}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>{"Choix Verouillage ou Cloture"}</DialogTitle>
                <DialogActions>
                    <LoadingButton
                        onClick={() => {
                            setOpenModalchoice(false);
                            setOpenModal(true);
                        }}
                        startIcon={<LockClockIcon />}
                        loading={loadingButton}
                        loadingPosition="end"
                        sx={btnStyle({
                            bgColor: "#FC8404",
                            hoverColor: "#FF9456"
                        })}
                        variant="contained"
                    >
                        Date De Verouillage
                    </LoadingButton>
                    <LoadingButton
                        onClick={() => { setOpenModalchoice(false); setOpenModalCloture(true); }}
                        startIcon={<LockPersonIcon />}
                        sx={{ textTransform: "none" }}
                        loadingPosition="end"
                        variant="contained"
                        color="inherit"
                    >
                        Date De Cloture
                    </LoadingButton>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openModalCloture}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => {
                    setOpenModalCloture(false);
                }}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>{"Confirmation Date De Cloture"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        {`La date ${decoupDate[2]}-${decoupDate[1]}-${decoupDate[0]} sera la date de
                       Cloture pour le mois de ${dateToLock()}. Etes-vous sûr de cela SVP ?`}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <LoadingButton
                        onClick={() => handleSaveCloture()}
                        startIcon={<SaveIcon />}
                        loading={loadingButton}
                        loadingPosition="end"
                        sx={btnStyle({
                            bgColor: "#FC8404",
                            hoverColor: "#FF9456"
                        })}
                        variant="contained"
                    >
                        Oui
                    </LoadingButton>
                    <LoadingButton
                        onClick={() => setOpenModalCloture(false)}
                        startIcon={<ExitToAppIcon />}
                        sx={{ textTransform: "none" }}
                        loadingPosition="end"
                        variant="contained"
                        color="inherit"
                    >
                        Non
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default DateVerrouillageRow;